import { MultiSelectProps } from '@procore/core-react/dist/_typedoc/MultiSelect/MultiSelect.types.json';
import * as React from 'react';
export default {
  MultiSelectProps,
  React
};